
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preco-regiao",
      function () {
        return require("private-next-pages/preco-regiao/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preco-regiao"])
      });
    }
  